import { Box, Flex } from "@chakra-ui/react";
import { Button, ColorIcon, colors, customEvent, HStack, VStack } from "goi_common";
import { useRouter } from "next/router";
import { ReactNode } from "react";
import { MatchRecommendationPackageType } from "../../type/MatchRecommendationType";

interface ServiceDetailProps {
  servicePackage: MatchRecommendationPackageType | undefined;
  isFirst?: boolean;
  hasMore?: boolean;
  handleCardClick?: () => void;
  quotationRequestId?: number;
}

const highlightBadge = (text: string) => {
  const regex = /(\d+)(\D(?!\d)|$)/g; // 정규식 패턴 설정
  return text.replace(regex, '<span class="orange650 caption_12_b">$1$2</span>'); // 숫자와 문자를 구분하여 <span>태그 추가
};
export const RecommendationServiceDetail = ({
  servicePackage,
  isFirst,
  hasMore,
  handleCardClick,
  quotationRequestId,
}: ServiceDetailProps) => {
  const router = useRouter();

  return (
    <>
      <HStack alignItems="center" justifyContent="space-between" padding="16px">
        <div className="subtitle_14_sb gray500">
          {servicePackage?.name
            ? `${servicePackage.name} ${(servicePackage.price / 10000).toFixed(0)}`
            : "???"}
        </div>
        <div className="subtitle_18_b gray900">
          {servicePackage?.price.toLocaleString() || "???,???"}&nbsp;
          <span className="subtitle_14_sb gray500">원</span>
        </div>
      </HStack>
      {isFirst || hasMore ? (
        <VStack
          alignItems="center"
          justifyContent="center"
          gap="20px"
          padding="0 24px"
          height="146px"
        >
          <Box wordBreak="keep-all" className="body_14_m gray500 font-center" whiteSpace="pre-line">
            고이의 장례지도사는 지금 이 순간부터 장례식장, 장지까지 상주님과 함께 해요
          </Box>
          <FooterButton
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "mtch_recomm_lst",
                  trigger_and_target: "no_result-uv_review",
                },
              });
              router.push("/review/");
            }}
          >
            다른 상주분들의 후기 더보기
          </FooterButton>
        </VStack>
      ) : (
        <VStack justifyContent="space-between" height="146px">
          <Flex padding="4px 16px" gridRowGap="4px" gridColumnGap="6px" flexWrap="wrap">
            {servicePackage?.badges?.map((badge: string) => {
              return (
                <Box
                  key={badge}
                  padding="6.5px 10px"
                  backgroundColor={colors.gray50}
                  className="caption_12_m gray700"
                  borderRadius="5px"
                  width="fit-content"
                  height="35px"
                  dangerouslySetInnerHTML={{ __html: highlightBadge(badge) }}
                ></Box>
              );
            })}
          </Flex>
          <HStack
            width="100%"
            alignItems="center"
            justifyContent="center"
            padding="24px 0"
            className="button_14_sb orange650"
            gap="4px"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "match_recommendation_detail",
                  trigger_and_target: "btn_dtl-uv_match_recomm_dtl",
                },
              });
              handleCardClick?.();
            }}
          >
            <span>자세히 알아보기</span>
            <ColorIcon
              name="arrow_right_small"
              width="16px"
              height="16px"
              color={colors.orange650}
            />
          </HStack>
        </VStack>
      )}
    </>
  );
};

function FooterButton({ children, onClick }: { children: ReactNode; onClick: () => void }) {
  return (
    <Button
      style={{
        padding: "10px 12px",
        borderRadius: "5px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        backgroundColor: colors.orange650,
      }}
      onClick={onClick}
      className="button_14_sb white"
    >
      {children}
    </Button>
  );
}
